<template>
  <main>
    <Header v-on:showLoginModal="loginModalVisible = true"/>
    <HeaderHero/>
    <MobileHero v-if="!isLoggedIn" v-on:showLoginModal="loginModalVisible = true"/>
    <EventList/>
    <SponsorList/>
    <BoothMap />
    <Grid/>
    <Footer v-on:showRegistrationModal="registrationModalVisible = true"/>
    <LoginModal
      v-if="loginModalVisible"
      v-on:close="loginModalVisible = false"
      v-on:showRegistrationModal="loginModalVisible = false; registrationModalVisible = true"
    />
    <RegistrationModal
      v-if="registrationModalVisible"
      v-on:close="registrationModalVisible = false"
      v-on:showLoginModal="registrationModalVisible = false; loginModalVisible = true"
    />
    <div class="install-prompt" v-bind:style="{visibility: isInstallPromptVisible ? 'visible' : 'hidden'}">
      <img v-bind:src="require('../assets/logo-small.png')" alt="DUMP Days logo" />
      <span>
        Otvori Dayse jednim klikom
      </span>
      <button v-on:click="installer()">DODAJ</button>
      <span class="close-install" v-on:click="rememberDecline()">x</span>
    </div>
  </main>
</template>

<script>
import Header from "@/components/landing-page/Header.vue";
import HeaderHero from "@/components/landing-page/HeaderHero.vue";
import Footer from "@/components/landing-page/Footer.vue";
import MobileHero from "@/components/landing-page/MobileHero.vue";
import SponsorList from "@/components/landing-page/SponsorList.vue";
import RegistrationModal from "@/components/landing-page/RegistrationModal.vue";
import LoginModal from "@/components/landing-page/LoginModal.vue";
import Grid from "@/components/landing-page/Grid.vue";
import EventList from "@/components/landing-page/EventList.vue";
import BoothMap from "@/components/landing-page/BoothMap.vue";

export default {
  name: "landing-page",
  components: {
    Header,
    HeaderHero,
    Footer,
    MobileHero,
    Grid,
    SponsorList,
    RegistrationModal,
    LoginModal,
    EventList,
    BoothMap
  },
  data() {
    return {
      registrationModalVisible: false,
      loginModalVisible: false,
      isInstallPromptVisible: false,
      installer: undefined
    };
  },
  computed: {
    isLoggedIn: function() {
      let token = localStorage.getItem("token");
      if (!token) return false;

      let decoded = this.$decode(token);
      if (!decoded) return false;

      return true;
    }
  },
  methods: {
    rememberDecline: function() {
      this.isInstallPromptVisible = false;
      localStorage.setItem('didDeclinePreviously', 'yes');
    }
  },
  mounted() {
    let installPrompt;
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      installPrompt = e;
      if(!localStorage.getItem('didDeclinePreviously'))
        this.isInstallPromptVisible = true;
    });

    this.installer = () => {
      this.isInstallPromptVisible = false;
      installPrompt.prompt();
      installPrompt.userChoice.then(() => {
        installPrompt = null;
        this.isInstallPromptVisible = false;
      });
    };
  }
};
</script>

<style>
main {
  overflow-x: hidden;
  overflow-y: hidden;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 1120px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.modal {
  font-family: "Fuse V.2 Display";
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: #fff;
}

.install-prompt {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1d9b90;
  font-family: "Fuse V.2 Display";
  padding: 10px 5px;
  color: white;
}

.install-prompt img {
  height: 30px;
  margin-right: 10px;
}

.install-prompt button {
  margin-left: 10px;
  text-decoration: none;
  display: inline-block;
  border: 0;
  padding: 10px 18px;
  background-color: #30cec1;
  border-radius: 22.5px;
  color: #fff;
  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 1px;
  font-weight: 600;
  font-family: "Fuse V.2 Display";
}

.install-prompt button:hover {
  cursor: pointer;
}

.close-install {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 30px;
  transform: scaleX(1.3);
}

.close-install:hover {
  cursor: pointer;
}

@media screen and (max-width: 450px) {
  .close-install {
    right: 3px;
    top: -12px;
  }

  .install-prompt img {
    margin-right: 2px;
  }

  .install-prompt button {
    padding: 10px;
    margin-left: 2px;
    margin-right: 20px;
  }
}

@media screen and (max-width: 350px) {
  .install-prompt button {
    margin-right: 10px;
  }
}

@media screen and (min-width: 450px) {
  .install-prompt {
    justify-content: center;
  }

  .install-prompt button {
    padding: 10px 18px;
    margin-left: 20px;
  }

  .install-prompt img {
    margin-right: 30px;
  }
}
</style>